<template>
  <div class="main_box">
    <div v-if="!empty" class="big_box">
      <!-- <div class="selcet_bo">
        <el-select size="mini" class="selcet" @change="getAll(index)" v-model="chong_value" placeholder="请选择">
          <el-option v-for="(item, index) in deviceList" :key="item.id" :label="item.deviceName" :value="index"> </el-option>
        </el-select>
      </div> -->
      <div class="center_box">
        <div class="center_text">{{ numericalDevices.deviceName }}</div>
        <div class="center_body">
          <div class="center_">
            <div class="center_img">
              <div :class="`center_infomation${index}`" v-for="(item, index) in numericalDevices.numericalDevices.slice(0, 9)" :key="item.id">
                <div class="infomation_head">{{ item.attributeName }}</div>
                <div class="infomation_body">
                  <span class="status_">{{ item.attributeName }}:</span> <span class="value_">{{ item.realData == '' ? '--' : item.realData }}</span
                  ><span class="attributeSymbol">{{ item.attributeSymbol }}</span>
                </div>
              </div>
              <div>
                <img class="center_img_chong" src="../../assets/img/shui.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div v-if="empty">
      <el-empty description="暂无绑定水质检测" :image-size="200"></el-empty>
    </div> -->
  </div>
</template>
<script>
export default {
  props: {
    numericalDevices: {}
  },
  data() {
    return {
      currentPage: 1, //初始页
      pagesize: 6, //    每页的数据
      total: 0, //总数
      picList: [],
      deviceList: [],
      informationList: [],
      showActive: 0,
      numericalDevices: [],
      environmentTemperature: {},
      ambientHumidity: {},
      longitude: [],
      rainGutter: '',
      signal: '',
      lightOperated: '',
      aisle: '',
      waterTemperature: '',
      heatingMedium: [],
      ammoniaNitrogen: '',
      address: '',
      empty: false,
      chong_value: 0
    }
  },
  mounted() {
    // this.getHomeMonitorList()
    // this.getInfomation()
  },
  methods: {
    getAll(index) {
      this.showActive = index
      this.numericalDevices = this.deviceList[index].numericalDevices
      this.address = this.deviceList[index].address
      this.numericalDevices.map(item => {
        item.updateTime = this.getHMS(item.updateTime)
      })
      this.getInfomation()
    },
    getInfomation() {
      this.rainGutter = ''
      this.signal = ''
      this.lightOperated = ''
      this.numericalDevices.map(item => {
        if (item.attributeName.includes('PH')) {
          this.rainGutter = item
        } else if (item.attributeName.includes('氧气含量')) {
          this.signal = item
        } else if (item.attributeName.includes('电导率')) {
          this.lightOperated = item
        } else if (item.attributeName.includes('水温')) {
          this.waterTemperature = item
        } else if (item.attributeName.includes('氨氮')) {
          this.ammoniaNitrogen = item
        }
      })
    },
    getHomeMonitorList() {
      //获取分组列表
      this.$api.device.getHomeMonitorList({ type: 2 }).then(res => {
        if (res.code == 200) {
          if (res.data.length == 0) {
            this.empty = true
          } else {
            this.empty = false
            this.deviceList = res.data
            this.deviceList.map(item => {
              item.numericalDevices.map(citem => {
                citem.updateTime = this.getHMS(citem.updateTime)
              })
            })
            // this.numericalDevices = this.deviceList[0].numericalDevices
            // this.numericalDevices.map(item => {
            //   item.updateTime = this.getHMS(item.updateTime)
            // })
            // this.getInfomation()
          }
        }
      })
    },
    getHMS(timestamp) {
      var date = new Date(timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '/'
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '/'
      var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '

      var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
      var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
      var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return Y + M + D + h + m + s
    },
    getPicImageList(id, imageAttributeId) {
      this.$api.device
        .getPicImageList(this.currentPage, this.pagesize, id, imageAttributeId)
        .then(res => {
          if (res.code == 200) {
            if (this.currentPage != 1 && res.data.length == 0) {
              this.currentPage = this.currentPage - 1
              //this.getDeviceList();
            } else {
              this.total = res.pageInfo.total
              if (res.data.length == 0) {
                this.empty = true
              } else {
                this.empty = false
              }
              this.picList = res.data
              this.picList.map(item => {
                item.createDate = this.getHMS(item.createDate)
              })
              console.log(this.picList)
            }
          } else {
            this.empty = false
            this.$toaster.error(res.msg)
          }
        })
        .catch(() => {})
    }
  }
}
</script>
<style scoped>
.swiper_title {
  font-size: 18px;
  margin-left: 2rem;
  font-weight: bold;
  color: #2494f2;
}
::-webkit-scrollbar {
  width: 8px;
  height: 10px;
}

::-webkit-scrollbar-thumb {
  background: #cecdcd;
  border-radius: 4px;
}

.big_box {
  display: flex;
  justify-content: space-around;
}
.left_box {
  margin-top: 20px;
  margin-left: 20px;
  margin-right: 20px;
  border-radius: 10px;
  width: 17%;
  background-color: #ffffff;
  height: 530px;
}
.left_head {
  width: 100%;
  height: 40px;
  line-height: 40px;

  background-color: #2494f2;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}
.center_head {
  width: 100%;
  height: 40px;
  line-height: 40px;
  font-size: 18px;
  margin-left: 20px;
  color: #2494f2;
  font-weight: bold;
}
.title {
  font-size: 16px;
  margin-left: 20px;
  color: #ffffff;
  font-weight: bold;
}
.left_body {
  height: 660px;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
}
.body {
  cursor: pointer;
  height: 120px;
  display: flex;
  align-items: center;
  margin: 8px;
  border-radius: 20px;
  border: 1px solid #c5c6c7;
  justify-content: center;
}
.active {
  border: 2px solid #9ecbf3;
}
.text {
  margin-top: 1rem;
  font-size: 15px;
  color: #4aaafd;
  margin-left: 10px;
}
.yellow {
  color: #fcb046;
  margin-top: 15px;
  margin-bottom: 20px;
}
.black {
  color: #000;
  font-weight: normal;
}
.alertbox {
  display: flex;
  justify-content: center;
}
.bg_img {
  width: 4.5rem;
}
.bottom_box {
  width: 100%;
  margin-left: 30px;
  display: flex;
  justify-content: space-between;
}
.bottom_box .el-button.is-round {
  border-radius: 15px !important;
}
.bottom_box .el-button {
  padding: 0px !important;
  text-align: center !important;
  width: 60px !important;
  height: 25px !important;
  line-height: 0px !important;
}

.right_box {
  margin-top: 20px;
  margin-right: 20px;
  border-radius: 10px;
  width: 16%;
  background-color: #ffffff;
  height: 730px;
}
.right_head {
  width: 100%;
  height: 40px;
  line-height: 40px;

  background-color: #2494f2;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}

.right_body {
  height: 660px;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
}
.right_body .body {
  height: 120px;
  display: flex;
  margin: 8px;
  border-radius: 20px;
  border: 2px solid #9ecbf3;
}

.center_box {
  margin-top: 20px;
  margin-right: 20px;
  border-radius: 10px;
  height: 600px;
  width: 70%;
}
.center_body {
  display: flex;
  height: 100%;
  position: relative;
  margin-top: 30px;
}
.center_ {
  width: 100%;
}
.center_infomation0 {
  position: absolute;
  top: 0rem;
  left: 18rem;
  border: 1.5px solid #60bef9;
  border-radius: 10px;
  box-shadow: 6px 6px 4px rgba(0, 0, 0, 0.5);
}
.center_infomation1 {
  position: absolute;
  top: 7rem;
  left: 14rem;
  border: 1.5px solid #60bef9;
  border-radius: 10px;
  box-shadow: 6px 6px 4px rgba(0, 0, 0, 0.5);
}
.center_infomation2 {
  position: absolute;
  top: 14rem;
  left: 14rem;
  border: 1.5px solid #60bef9;
  border-radius: 10px;
  box-shadow: 6px 6px 4px rgba(0, 0, 0, 0.5);
}
.center_infomation3 {
  position: absolute;
  top: 21rem;
  left: 18rem;
  border: 1.5px solid #60bef9;
  border-radius: 10px;
  box-shadow: 6px 6px 4px rgba(0, 0, 0, 0.5);
}

.center_infomation4 {
  position: absolute;
  top: 1rem;
  right: 20rem;
  border: 1.5px solid #60bef9;
  border-radius: 10px;
  box-shadow: 6px 6px 4px rgba(0, 0, 0, 0.5);
}
.center_infomation5 {
  position: absolute;
  top: 6.5rem;
  right: 16rem;
  border: 1.5px solid #60bef9;
  border-radius: 10px;
  box-shadow: 6px 6px 4px rgba(0, 0, 0, 0.5);
}
.center_infomation6 {
  position: absolute;
  top: 12rem;
  right: 13rem;
  border: 1.5px solid #60bef9;
  border-radius: 10px;
  box-shadow: 6px 6px 4px rgba(0, 0, 0, 0.5);
}
.center_infomation7 {
  position: absolute;
  top: 17.5rem;
  right: 16rem;
  border: 1.5px solid #60bef9;
  border-radius: 10px;
  box-shadow: 6px 6px 4px rgba(0, 0, 0, 0.5);
}
.center_infomation8 {
  position: absolute;
  top: 23rem;
  right: 20rem;
  border: 1.5px solid #60bef9;
  border-radius: 10px;
  box-shadow: 6px 6px 4px rgba(0, 0, 0, 0.5);
}
.gk {
  top: 38rem;
  left: 14rem;
}
.jrc {
  top: 27rem;
}
.xhtx {
  top: 25rem;
  left: 48.5rem;
}
.td {
  left: 52rem;
  top: 18rem;
}
.cm {
  left: 52rem;
  top: 27rem;
}
.infomation_head {
  width: 8rem;
  height: 30px;
  line-height: 35px;
  background-color: #2494f2;
  /* border-radius: 5px; */
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  color: #ffffff;
  text-align: center;
  font-size: 13px;
  font-weight: bold;
}

.infomation_body {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 8rem;
  height: 40px;
  text-align: center;
  font-size: 13px;
}
.jrc_ {
  height: 50px;
}
.status_ {
  color: #999999;
}
.value_ {
  font-weight: bold;
}
.center_img_chong {
  width: 22rem;
  position: relative;
  left: 35%;
  margin-top: 3rem;
}
.center_img {
  width: 100%;
  margin-bottom: 1rem;
  /* background-color: #ffffff; */
  border-radius: 20px;
}

.qi {
  width: 32rem;
  /* height: 50rem; */
  height: 100%;
}
.shui {
  width: 40rem;
  margin-left: 10rem;
  margin-top: 2rem;
}
.center_right {
  margin-left: -1rem;
  height: 100%;
}
.center_right_title {
  margin-left: 1.2rem;
}
.center_right_title_ {
  font-size: 17px;
  font-weight: bold;
}
.center_right_img {
  width: 4.8rem;
  margin-left: 1rem;
  margin-top: 0.5rem;
}

.null {
  font-weight: normal;
  font-size: 15px;
  color: #a19ebd;
  margin-top: 0.5rem;
}
.center_rightBoxs {
  margin-top: 2rem;
  margin-left: 3rem;
  width: 16rem;
  height: 10rem;
  display: flex;
  justify-content: center;
  align-items: center;
  /* background-color: #09f87c; */
  border-bottom: 1px solid #a19ebd;
}
.center_rightBoxs_q {
  margin-top: 2rem;
  margin-left: 3rem;
  width: 16rem;
  height: 10rem;
  display: flex;
  justify-content: center;
  align-items: center;
  /* background-color: #09f87c; */
  border-bottom: 1px solid #a19ebd;
}
.right_body .bottom_box {
  margin-left: 5px;
  align-items: center;
}
.right_body .bottom_box .time {
  margin-left: 5px;
  font-size: 10px;
  font-weight: bold;
}
.right_body .bottom_box .el-button {
  width: 80px !important;
}
.num {
  font-size: 23px;
  color: #000;
  margin-top: 5px;
}
.unit {
  font-size: 14px;
}
.bg_box {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.bg_box_img {
  margin-top: 1rem;
}
.body_ {
  margin-left: 10px;
  position: relative;
  width: 100%;
  height: 60%;
  display: flex;
  margin-top: 10px;
}
.status {
  position: absolute;
  float: right;
  right: 15px;
  font-weight: bold;
  color: #09f87c;
}
.status1 {
  color: #aaaaaa;
}
.status1 {
  color: red;
}
.attributeSymbol {
  font-size: 10px;
  font-weight: bold;
}
.selcet {
  width: 225px !important;
  z-index: 99999;
  float: right;
}
.selcet_bo {
  position: absolute;
  right: 15px;
}
.main_box {
  width: 100%;
  height: 100%;
}
.center_text {
  width: 100%;
  height: 36px;
  font-size: 26px;
  text-align: center;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: bold;
  color: #333;
  line-height: 36px;
  /* margin-left: 60px; */
}
</style>
